export function lastChangedAt(timestamp: string) {
	const past = new Date(timestamp);
	const now = new Date();

	const msInDay = 1000 * 60 * 60 * 24;

	const deltaMs = now.getTime() - past.getTime();
	const days = Math.floor(deltaMs / msInDay);

	// Convert to 12-hour format with AM/PM
	let hours = past.getHours();
	const ampm = hours >= 12 ? "PM" : "AM";
	hours = hours % 12;
	if (hours === 0) hours = 12; // 12 AM or 12 PM

	const minutes = past.getMinutes().toString().padStart(2, "0");

	const timeStr = `${hours}:${minutes} ${ampm}`;

	if (days === 0) {
		return `Today, ${timeStr}`;
	}

	return `${days}d ago, ${timeStr}`;
}
